import { Box, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import GoogleLoginView from "./GoogleLoginView";
import SingInIcon from '@mui/icons-material/Login';

const SignInModalView = (props) => {
    return (
        <Dialog open={props.open} fullWidth maxWidth="xs" onClose={
            (event, reason) => {
                if (reason && reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
                props.close()
            }
        }
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 4
                },
            }}
        >
            <DialogTitle sx={{ p: 3 }}><Typography variant="h5" sx={{ fontWeight: 600, opacity:.8 }}>Ad Free Lyrics<sup style={{ fontSize: 12, bottom: 5, left: 2, position: "relative" }}>admin</sup> </Typography></DialogTitle>
            <DialogContent>

                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1, pb:1.5 }}>
                    <Box sx={{ display: "flex", gap:.5, opacity: .6 , alignItems:"center"}}><SingInIcon sx={{fontSize:18}}/><Typography>Login here</Typography></Box>
                    <GoogleLoginView />
                    <Typography variant="caption" sx={{opacity: .6}}>You must login to add songs</Typography>
                </Box>

            </DialogContent>

        </Dialog>
    );
};

export default SignInModalView;